import React, { Fragment } from 'react';
import type { WRelatedLinkView } from '@zola/svc-web-api-ts-client';

import { LinkV2 } from '../LinkV2';
import { StyledLi, StyledUl } from './AdviceItem.styles';
import PreAuthCarouselCard, { PreAuthCarouselCardProps } from './PreAuthCarouselCard';

export type AdviceItemProps = {
  card?: PreAuthCarouselCardProps;
  links?: WRelatedLinkView[];
};

const AdviceItem: React.FC<AdviceItemProps> = (props: AdviceItemProps) => {
  const { card, links } = props;
  if (!card && !links) {
    return <Fragment />;
  }

  if (card) {
    return <PreAuthCarouselCard {...card} />;
  }

  return (
    <StyledUl>
      {links?.map((link, i) => {
        const { title: linkText, url_path: href } = link;
        return (
          <StyledLi key={i}>
            <LinkV2 href={href} subtle noUnderline variant="tertiary">
              {linkText}
            </LinkV2>
          </StyledLi>
        );
      })}
    </StyledUl>
  );
};

export default AdviceItem;
